import mayaAsset from "@/assets/maya/maya-calendar-2026.png.asset.json";

/** Single source of truth for Maya's character artwork (transparent PNG). */
export const MAYA_IMAGE_URL: string = mayaAsset.url;
